import { render, staticRenderFns } from "./CreateCampaignSourceCollectionsItem.vue?vue&type=template&id=30f513d7&scoped=true"
import script from "./CreateCampaignSourceCollectionsItem.vue?vue&type=script&lang=js"
export * from "./CreateCampaignSourceCollectionsItem.vue?vue&type=script&lang=js"
import style0 from "./CreateCampaignSourceCollectionsItem.vue?vue&type=style&index=0&id=30f513d7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f513d7",
  null
  
)

export default component.exports